/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { EvidenceItem, EvidenceStatus } from "./getTraceDetail";

export type ScanMessage = {
  role: "system" | "user" | "assistant";
  content: string;
};

export type ScanRequestType = {
  serviceToken: string;
  model?: string;
  scan_type: "input" | "response";
  messages: ScanMessage[];
  policy_names?: string[];
  session_id?: string;
};

export type PiiMetadata = EvidenceItem;

export type ViolationResult = {
  violated_policy_name: string;
  violated_rules_list: string[] | null;
  rationale: string;
  type: string;
  metadata?: PiiMetadata[];
  evidence_status?: EvidenceStatus;
  evidence?: EvidenceItem[];
};

export type ScanResponse = {
  decision: "SAFE" | "UNSAFE";
  trace_id: string;
  latency_ms?: number;
  xecguard_result: ViolationResult[] | null;
};

export default function postScan({
  serviceToken,
  model = "xecguard_v2",
  scan_type,
  messages,
  policy_names,
  session_id,
}: ScanRequestType): Promise<InternalResponse<ScanResponse>> {
  return request()({
    url: "/xecguard/v1/scan",
    method: "POST",
    data: {
      model,
      scan_type,
      messages,
      ...(policy_names && policy_names.length > 0 ? { policy_names } : {}),
      ...(session_id ? { session_id } : {}),
    },
    headers: { Authorization: `Bearer ${serviceToken}` },
  }).then(
    (result: AxiosResponse<ScanResponse>): InternalResponse<ScanResponse> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.response?.status ?? error.code,
    msg: error.response?.data
      ? JSON.stringify(error.response.data)
      : error.message,
    success: false,
  }));
}
